<template>
  <!-- Layout for sign-in/sign-up -->
  <div class="auth-layout">
    <Alert />
    <RouterView />
  </div>
</template>
<script>
import Alert from '@/components/common/Alert'
export default {
  name: 'Auth',
  components: {
    Alert
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // console.log('vm.$i18n.locale', vm.$i18n.locale, '$route.params.locale')
      const correctLocalePath = vm.$i18n.localePath() // include prefix '/'
      const locale = vm.$route.params.locale
      if (correctLocalePath !== `${locale}`) {
        // Replacing languageCode to countryCode force in path
        vm.$router.replace({ params: { locale: correctLocalePath } })
      }
    })
  },
  props: {},
  data() {
    return {}
  },
  metaInfo() {
    return {
      htmlAttrs: {
        lang: this.htmlLang
      },
      meta: [
        { vmid: 'og:site_name', name: 'og:site_name', content: this.siteName }
      ]
    }
  },
  computed: {
    htmlLang() {
      if (this.$i18n.locale.toLowerCase() === 'zh-tw') {
        return 'zh-Hant'
      } else if (this.$i18n.locale.toLowerCase() === 'zh-cn') {
        return 'zh-Hans'
      } else if (this.$i18n.locale.toLowerCase() === 'en-us') {
        return 'en'
      } else if (this.$i18n.locale.toLowerCase() === 'ja-jp') {
        return 'ja'
      } else {
        return 'en'
      }
    },
    siteName() {
      return `MUZIK AIR`
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@media only screen and (max-width: 1439.98px) {}
@media only screen and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
